import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Fetches a private document as a blob (auth header) and renders image or PDF.
export function DocumentPreview({ doc }) {
  const { t } = useI18n();
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const isPdf = doc.content_type === "application/pdf";

  useEffect(() => {
    let objectUrl;
    let active = true;
    (async () => {
      try {
        const res = await api.get(`/documents/${doc.id}/download`, { responseType: "blob" });
        if (!active) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [doc.id]);

  return (
    <div className="flex flex-col">
      <div className="border-b border-[#E2EAE5] px-4 py-3">
        <DialogTitle className="truncate font-display text-sm font-bold text-[#1A2E26]">
          {doc.original_filename}
        </DialogTitle>
        <DialogDescription className="sr-only">{doc.original_filename}</DialogDescription>
      </div>
      <div className="flex min-h-[60vh] items-center justify-center bg-[#F0F4F1]">
        {loading ? (
          <Loader2 size={24} className="animate-spin text-[#2D5A4C]" />
        ) : url ? (
          isPdf ? (
            <iframe data-testid="preview-pdf" title={doc.original_filename} src={url} className="h-[70vh] w-full" />
          ) : (
            <img data-testid="preview-image" src={url} alt={doc.original_filename} className="max-h-[70vh] w-full object-contain" />
          )
        ) : (
          <p className="text-sm text-[#7A9488]">{t("common.retry")}</p>
        )}
      </div>
    </div>
  );
}
